module.exports = __webpack_public_path__ + "static/img/security-icon4.a203d00e.png";